
import {Vue, Component, Prop} from 'vue-property-decorator';
import ContainerLoadingInfoComponent from "@/views/components/ContainerLoadingInfoComponent.vue";
import Template from "@/views/system-management/template/index.vue";
import {Company} from "@/model/booking-order";
import {saveContainerType} from "@/api/shipping-order";
import {getLoadingPlanListDetail} from "@/api/booking-order";
import {PackingVolume, ProblemType, State} from "@/model/HenganLoadingPlanModels";
import {CustomsPackingCode} from "@/model/HqPackingListModels";

@Component({
  name: "ShippingOrderInfo",
  components: {Template, ContainerLoadingInfoComponent}
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private edit: boolean;
  @Prop({ required: true, default: "" }) private loadingPlanListId: string;

  private loading = false;
  private loadingPlanListDetail: LoadingPlanListDetailResponse = new LoadingPlanListDetailResponse();
  private containerLoadingInfos: ContainerLoadingInfoData[] = [];

  private async open() {
    this.loading = true;
    const data: any = await getLoadingPlanListDetail(this.loadingPlanListId);
    this.loadingPlanListDetail = data;
    this.containerLoadingInfos = data.loadingInfos.map((value) => {
      const containerLoadingInfo: ContainerLoadingInfoData = { ...value };
      containerLoadingInfo.type = value.loadingPlanType;
      containerLoadingInfo.loadingPlans = value.loadingPlans.map(
          (loadingPlan) => {
            const loadingPlanInfo = new LoadingPlanInfo();
            loadingPlanInfo.id = loadingPlan.id;
            loadingPlanInfo.type = loadingPlan.loadingPlanType;
            loadingPlanInfo.code = loadingPlan.loadingPlanCode;
            loadingPlanInfo.customsPackingInfos = loadingPlan.customsPackingSet;
            return loadingPlanInfo;
          }
      );
      return containerLoadingInfo;
    });
    this.loading = false;
  }

  private close() {
    this.$emit("update:show", false);
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }

  private async saveShippingOrder() {
    let list = [];
    this.containerLoadingInfos.forEach((item, index) => {
      list.push(
          (this.$refs[`shippingOrderContainer${index}`][0] as Vue & { data_: Object; }).data_
      );
    });

    const containerTypes = list.map((value) => {
      return {
        containerTypeId: value.containerTypeId,
        containerNumber: value.containerNumber,
        sealNumber: value.sealNumber,
        weight: value.weight,
      };
    });
    await saveContainerType({containerTypeRequestList: containerTypes,});
    this.$emit("update:show", false);
  }

}

class LoadingPlanListDetailResponse {
  id: string;
  bookingOrderCode: string;
  customerAbbr: string;
  shippingOrderCode: string;
  billLadingCode: string;
  forwardingCompanies: Company[];
  loadingInfos: LoadingPlan[];
}

class LoadingPlan {
  id: string;
  loadingPlanType: LoadingPlanType;
  code: string;
  createdAt: string;
  category: string;
  factoryNames: string;
  containerTypeInfos: string[];
  totalPCS: number;
  totalAmount: string;
  volumes: string;
  customerId: string;
  customsPackingSet?: CustomsPackingModel[];
}

class CustomsPackingModel {
  id: string;
  code: CustomsPackingCode;
  hqPackingListId: string;
  hqPackingListCode: string;
  packingVolume: PackingVolume;
  netWeight: number;
  grossWeight: number;
  packingQuantity: number;
  customsPackingVolume: number;
  productQuantity: number;
  state: State;
  ackType: string;
  loadingFirst: boolean;
  createdAt: Date;
  factoryName?: string;
  problemType?: ProblemType;
  secondaryPackings: SecondaryPackingModel[] = [];
  avgNetWeight: number;
  avgGrossWeight: number;
}

class SecondaryPackingModel {
  grossWeight: number;
  netWeight: number;
  packingVolume: PackingVolume;
  product: ProductInfoModel;
}

class ProductInfoModel {
  declarationDescription: string;
  description: string;
  englishName: string;
  guestModel: string;
  hqOrJrNumber: any;
  hsNumber: string;
  id: string;
  nameWithModel: string;
  oeNumber: string;
  packingNumberPcs: number;
  poNumber: any;
  refNumber: string;
  totalNumberPcs: number;
  avgGrossWeightDescription: number;
  avgNetWeightDescription: number;
  grossWeight: number;
  netWeight: number;
}

export class ContainerLoadingInfoData {
  id: string;
  containerId: string;
  billOfLadingCode?: string; // 海运提单号
  containerTypeCode: string; // 柜型
  containerNumber: string; // 集装箱号
  sealNumber: string; // 铅封号
  logisticsCompany: string; // 物流公司
  licensePlateNumber: string; // 车牌号
  driverTel: string; // 司机号码
  weight: string; // 集装箱重量
  remark: string; // 装柜信息
  category: string;
  type: LoadingPlanType;
  palletQuantity: number;
  cartonsQuantity: number;
  totalProductQuantity: number;
  totalVolume: string;
  containerTypeRemark: string;
  loadingPlans: LoadingPlanInfo[] = [];
}

export class LoadingPlanInfo {
  id: string;
  type: LoadingPlanType;
  code: string;
  customsPackingInfos: CustomsPackingModel[] = [];
}

export class LoadingPlanType {
  name: string;
  desc: string;
}
